module.exports = __webpack_public_path__ + "static/img/img_5.354506ec.jpg";